import { getLocation } from '@change-corgi/core/window';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useCurrentUserRole } from '#src/app/shared/hooks/session';

import { resetCacheApi } from './api';

type Result = ModelHookResult<
	{
		userIsStaff: boolean;
	},
	{
		resetCache: () => Promise<void>;
	}
>;

export function useResetCache(): Result {
	const utilityContext = useUtilityContext();

	const userIsStaff = useCurrentUserRole('staff');

	async function resetCache() {
		await resetCacheApi(utilityContext);
		getLocation().reload();
	}

	return {
		data: {
			userIsStaff,
		},
		actions: {
			resetCache,
		},
	};
}
